














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { store, EmojiIndex } from 'emoji-mart-vue-fast';
import { IEmoji, IEmojiLocalization } from '@getaccept/lib-ui';
import { EmojiHelper } from '@lib-shared/emoji/helpers/emoji.helper';
import { EMOJI_INLINE_TRIGGER_COUNT } from '@lib-shared/emoji/constants/emoji.constants';
import { ChatHelper } from '@lib-shared/chat/helpers/chat.helper';

@Component({
  data: () => ({
    ChatHelper,
  }),
})
export default class ChatActions extends Vue {
  @Prop() isPreview: boolean;
  @Prop({ default: false }) emojisEnabled: boolean;

  text = '';
  skinTone = 0;
  emojiSearch = '';
  selectedInlineEmojiIndex = 0;
  showSendButtonTooltip = false;
  showEmojiButtonTooltip = false;
  showEmojis = false;
  showInlineEmojiMenu = false;
  tooltipDelay = 3000;
  localization: IEmojiLocalization;
  emojiIndex: EmojiIndex = EmojiHelper.emojiIndex();

  get matchedEmojis(): IEmoji[] {
    return EmojiHelper.getEmojiListByKey(this.emojiSearch);
  }

  get correctEmojiSearch(): boolean {
    return (
      this.emojiSearch.charAt(0) === ':' &&
      this.emojiSearch.length >= EMOJI_INLINE_TRIGGER_COUNT &&
      this.matchedEmojis.length > 0 &&
      !this.emojiSearch.includes(' ')
    );
  }

  handleSkinChange(skinTone: number) {
    this.skinTone = skinTone;
  }

  isEndingColon(text: string): boolean {
    return text.charAt(text.length - 1) === ':';
  }

  handleInput() {
    if (!this.emojisEnabled) {
      return;
    }
    this.emojiSearch = this.getEmojiKey(this.inputRef, this.text);
    const isEndingColon = this.isEndingColon(this.emojiSearch);
    this.selectedInlineEmojiIndex = 0;

    if (isEndingColon && this.correctEmojiSearch) {
      const emoji = EmojiHelper.getEmojiFromKey(this.emojiSearch);
      this.replaceEmojiSearchWithEmoji(emoji);
      return;
    }

    if (this.correctEmojiSearch && !this.showInlineEmojiMenu) {
      this.setShowInlineEmojiMenu(true);
      return;
    }
    if (!this.correctEmojiSearch) {
      this.resetInlineEmojiMenu();
    }
  }

  get inputRef(): HTMLTextAreaElement {
    return this.$refs.input as HTMLTextAreaElement;
  }

  getEmojiKey(element: HTMLTextAreaElement, text: string): string {
    const end: number = element.selectionEnd;
    const start: number = text.lastIndexOf(':', end - 2);
    return start >= 0 ? text.substring(start, end) : '';
  }

  resetInlineEmojiMenu() {
    this.setShowInlineEmojiMenu(false);
    this.emojiSearch = '';
    this.selectedInlineEmojiIndex = 0;
  }

  setShowInlineEmojiMenu(show: boolean) {
    this.showInlineEmojiMenu = show;
  }

  setShowEmojiPicker(show: boolean) {
    this.showEmojis = show;
  }

  handleSendButtonTooltip() {
    if (this.showSendButtonTooltip) {
      return;
    }
    this.showSendButtonTooltip = true;
    setTimeout(() => {
      this.showSendButtonTooltip = false;
    }, this.tooltipDelay);
  }

  handleEmojiButtonTooltip() {
    if (this.showEmojiButtonTooltip) {
      return;
    }
    this.showEmojiButtonTooltip = true;
    setTimeout(() => {
      this.showEmojiButtonTooltip = false;
    }, this.tooltipDelay);
  }

  toggleEmojis() {
    this.showEmojis = !this.showEmojis;
  }

  async handleAddEmoji(emoji: IEmoji) {
    const cursorPosition: number = this.inputRef.selectionEnd;
    this.setShowEmojiPicker(false);
    this.text = this.text.slice(0, cursorPosition) + emoji.native + this.text.slice(cursorPosition);
    this.inputRef.focus();
    await this.$nextTick();
    this.inputRef.setSelectionRange(
      cursorPosition + emoji.native.length,
      cursorPosition + emoji.native.length
    );
  }

  async replaceEmojiSearchWithEmoji(emoji: IEmoji) {
    const nativeEmoji: string = EmojiHelper.getEmojiWithSkinTone(emoji, this.skinTone)?.native;
    if (!nativeEmoji) {
      this.resetInlineEmojiMenu();
      return;
    }
    const cursorPosition: number =
      this.inputRef.selectionEnd - this.emojiSearch.length + nativeEmoji.length;
    this.text = this.text.replace(this.emojiSearch, nativeEmoji);
    this.resetInlineEmojiMenu();
    await this.$nextTick();
    this.inputRef.setSelectionRange(cursorPosition, cursorPosition);
  }

  handleSend() {
    if (this.isPreview) {
      this.handleSendButtonTooltip();
      return;
    }
    this.setFocus();
    if (this.text) {
      this.$emit('send', EmojiHelper.encode(this.text));
      this.text = '';
    }
  }

  setFocus() {
    this.inputRef.focus();
  }

  clickOutside() {
    if (!this.showEmojis) {
      return;
    }
    this.setShowEmojiPicker(false);
  }

  handleEnter() {
    if (this.showInlineEmojiMenu) {
      this.replaceEmojiSearchWithEmoji(this.matchedEmojis[this.selectedInlineEmojiIndex]);
    } else {
      this.handleSend();
    }
  }

  handleTab(event) {
    if (this.showInlineEmojiMenu) {
      event.preventDefault();
      this.replaceEmojiSearchWithEmoji(this.matchedEmojis[this.selectedInlineEmojiIndex]);
    }
  }

  handleNavigate(event: KeyboardEvent) {
    if (!this.showInlineEmojiMenu) {
      return;
    }
    event.preventDefault();
    const firstSelected: boolean = this.selectedInlineEmojiIndex === 0;
    const lastSelected: boolean = this.selectedInlineEmojiIndex === this.matchedEmojis.length - 1;

    let step: number;
    switch (event.key) {
      case 'ArrowUp':
        if (firstSelected) {
          return;
        }
        step = -1;
        break;
      case 'ArrowDown':
        if (lastSelected) {
          return;
        }
        step = 1;
        break;
    }

    this.selectedInlineEmojiIndex += step;
  }
  mounted() {
    this.skinTone = store.get('skin');
  }
}
